import MasterComponent from "../../components/Forms";
import { MasterConfigs } from "../../interfaces/entity";

const ListTypes = () => {
    const config: MasterConfigs = {
        api: () => '/leads-types',
        modalTitle: () => 'Lead Type',
        isActionTab: true,
        getFormColumns: () => [
            {
                name: 'name',
                label: 'Name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }],
                span: 8
            },
            {
                span: 16,
            },
            {
                name: 'description',
                label: 'Description',
                type: 'textarea',
                span: 16,
            }
        ],
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                ellipsis: true
            }
        ],
        actions: [
            {
                name: 'add',
                actionType: 'Add'
            }
        ]
    }

    return (
        <MasterComponent config={config} isModal={true} />
    )
}

export default ListTypes;